export default __webpack_public_path__ + "static/media/PowertoServe_Thumbnail.4a899a51.jpg";